import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 20,
    display: 'flex',
    justifyContent: 'center'
  },
  imageContainer: {
    width: 70,
    height: 70,
    borderRadius: 35,
    position: 'relative',
    overflow: 'hidden',
    transition: 'background-color 0.5s ease-in-out',
    cursor: 'pointer',
    '&:hover': {
      '& div': { opacity: 1 }
    }
  },
  image: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    bottom: 0,
    left: 0,
    transition: 'opacity 0.2s linear'
  },
  imageButton: {
    position: 'absolute',
    bottom: 0,
    backgroundColor: theme.palette.background.default,
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    }
  }
}))
export default useStyles
